import React, { useEffect, useState } from 'react'
import {brainzBalance, rerollAll, rerollTrait} from '../../../Contract/Web3Client'
import {
  RerollContainer,
  Heading,
  Subtitle,
  FormContainer,
  RerollForm,
  RerollSelect,
  Label,
  SelectOption,
  RerollSubmit,
  RerollAllButton,
  TextField
} from './RerollElements'
import {RerollTrait} from "../../../utils/Enums";

const Reroll = ({tokens, address}) => {
  const [id, setId] = useState(0)
  const [trait, setTrait] = useState(0)
  const [brainz, setBrainz] = useState(0)

  useEffect(async () => {
      setBrainz(await brainzBalance(address))
  }, [address])

    useEffect(async () => {
        setId(tokens.length === 0 ? 0 : tokens[0].tokenId);
    }, [tokens])

  const submitForm = () => {
    console.log("token is: " + id)
    console.log("Trait is: " + trait)
    console.log(tokens.find(x => x.tokenId === id))
    rerollTrait(id, trait, address)
  }

  const rrall = () => {
      rerollAll(id, address);
  }

  let populateIdDropdown = tokens.map(d => (
    <SelectOption key={d.tokenId} value={d.tokenId}>{d.name}</SelectOption>
  ))
  
  let populateTraitDropdown = RerollTrait.enumerate.map((name, i) => (
    <SelectOption key={i} value={i}>{name}</SelectOption>
  ))  

  return (
    <>
      <RerollContainer>
        <Heading>Reroll Traits</Heading>
        <TextField>$BRAINZ: {brainz}</TextField>
        <FormContainer>
         <RerollForm
            onSubmit={e => {
              e.preventDefault()
              submitForm()
            }}>
            <Label>
              Select Bit Monster ID:
              <RerollSelect
                value={id}
                onChange={e => setId(parseInt(e.target.value, 10))}>
                {populateIdDropdown}
              </RerollSelect>
            </Label>
            <Label>
              Select Trait To Reroll:
              <RerollSelect
                value={trait}
                onChange={e => setTrait(parseInt(e.target.value, 10))}>
                {populateTraitDropdown}
              </RerollSelect>
            </Label>
            <RerollSubmit type="submit" value="Reroll Trait" />
            <Subtitle>OR</Subtitle>
            <RerollAllButton 
              onClick={rrall}>
                Reroll All Traits
            </RerollAllButton>
          </RerollForm>
        </FormContainer>
      </RerollContainer>
    </>
  )
}

export default Reroll